import { motion } from "framer-motion";
import {
  Scissors,
  Youtube,
  Sparkles,
  Palette,
  AudioWaveform,
  Image as ImageIcon,
  Repeat,
  User,
  Camera,
} from "lucide-react";
import { SectionHead, Reveal } from "./effects";

const services = [
  { icon: Camera, title: "UGC Content", desc: "Authentic product videos & styled photography that make brands feel human and convert." },
  { icon: Scissors, title: "Short Form Editing", desc: "Reels, Shorts & TikToks engineered for hooks, retention and shares." },
  { icon: Youtube, title: "YouTube Editing", desc: "Long-form storytelling with pacing that keeps viewers to the end." },
  { icon: Sparkles, title: "Motion Graphics", desc: "Kinetic typography, animated explainers and branded visual FX." },
  { icon: Palette, title: "Color Grading", desc: "Cinematic looks that give every frame a premium, filmic finish." },
  { icon: AudioWaveform, title: "Sound Design", desc: "SFX, mixing and mastering that make edits feel expensive." },
  { icon: ImageIcon, title: "Thumbnail Design", desc: "CTR-optimized thumbnails built to win the click." },
  { icon: Repeat, title: "Content Repurposing", desc: "One long video becomes a week of high-performing short-form." },
  { icon: User, title: "Personal Branding Videos", desc: "Signature editing styles that make founders & creators recognizable." },
];

export const Services = () => (
  <section id="services" data-testid="services-section" className="relative py-24 sm:py-32 bg-[#070709]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHead
        testId="services"
        eyebrow="Services"
        title={
          <>
            What I can <span className="text-gradient-blue">help you with</span>
          </>
        }
        sub="Full-stack video editing — from the first cut to the final grade."
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {services.map((s, i) => (
          <Reveal key={s.title} delay={(i % 4) * 0.08}>
            <motion.div
              data-testid={`service-card-${s.title.toLowerCase().replace(/\s+/g, "-")}`}
              whileHover={{ y: -6 }}
              transition={{ type: "spring", stiffness: 240, damping: 18 }}
              className="group glass rounded-2xl p-6 h-full hover:border-[#D4AF37]/50 hover:shadow-[0_0_40px_rgba(212,175,55,0.18)] transition-all duration-500"
            >
              <div className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#D4AF37]/12 border border-[#D4AF37]/25 text-[#F5DE81] group-hover:bg-[#D4AF37]/25 group-hover:scale-110 transition-all duration-400">
                <s.icon size={22} strokeWidth={1.6} />
              </div>
              <h3 className="font-display text-base font-semibold mb-2">{s.title}</h3>
              <p className="text-[13px] text-slate-400 leading-relaxed">{s.desc}</p>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
